export default __webpack_public_path__ + "7c669a22395b1ee55095a8c1e373466b.png";